import { Link as ChakraLink, LinkProps } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

import { fontWeights } from '../global/Fonts';

export const Link = forwardRef<HTMLAnchorElement, LinkProps & RouterLinkProps>((props, ref) => {
  return <ChakraLink ref={ref} color="accent" fontWeight={fontWeights.bold} as={RouterLink} {...props} />;
});

Link.displayName = 'Link';

export default Link;
